import React from 'react';
import { Stage, Container } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { SCALE_MODES, MIPMAP_MODES, BaseTexture } from 'pixi.js';
import PixiTurnTimer from "./PixiTurnTimer";
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"
import PixiScaledButton from "./PixiScaledButton"
import PixiAutoCameraFramingDisplay from "./PixiAutoCameraFramingDisplay"
import PixiBoard from "./PixiBoard"
import PixiGamePlayersInfoPanel from "./PixiGamePlayersInfoPanel"
import PixiEndGamePhasePanel from "./PixiEndGamePhasePanel"
import PixiEndGameOverlay from "./PixiEndGameOverlay"
import { emit } from '../Socket/game.Emitters';
import { utils } from '../../utils'

import { gameStateManager } from '../../App';
import { GAME_STATE } from '../Core/GameStateManager';

const tileFolderName = "v2"; //"legacy"; //"v1";

class PixiGame extends React.Component
{
  state = {

    debugViewEndGamePhasePanel: false,
    debugViewGameOverPanel: false,

    viewFieldStates: false,
    viewRemainingTilesInfoPanel: false,

    gameOverScreenViewingBoardState: false,

    lastPlayerTileHighlightRequests: [],

    consoleInfoHighlightTile: null,
    consoleInfoHighlightRequestIndex: 0
  };


  textStyle = {
    fontFamily: "Radio Canada",
    align: "center",
    fill: "#000000",
  };


  onGameStateChangedCallbackHandle = null;
  isInitialized = false; // Flag to prevent double initialization in React Strict Mode


  constructor( props )
  {
    super( props );

    BaseTexture.defaultOptions.scaleMode = SCALE_MODES.NEAREST;

    // Off by default, and then manually applied for textures where it matters.
    BaseTexture.defaultOptions.mipmap = MIPMAP_MODES.OFF;

    this.pixiBoardRef = React.createRef();
  }

  componentDidMount()
  {
    // Prevent double initialization in React Strict Mode
    if( this.isInitialized ) return;
    this.isInitialized = true;

    // Register for key down event listening
    window.addEventListener( 'keydown', this.handleKeyDown );

    this.onGameStateChangedCallbackHandle = ( gameStateData ) =>
    {
      // console.log( "PIXI GAME -  New Game State ", gameStateData );

      this.setState( { gameStateData: gameStateData } );
    };

    gameStateManager.onGameStateChangedRegister( this.onGameStateChangedCallbackHandle );
    gameStateManager.addOnGameInfoConsoleTileHighlightRequestCallback( this.onGameInfoConsoleTileHighlightRequest );
  }

  componentWillUnmount()
  {
    // Clean up the keydown event listening
    window.removeEventListener( 'keydown', this.handleKeyDown );

    gameStateManager.onGameStateChangedUnregister( this.onGameStateChangedCallbackHandle );
    this.onGameStateChangedCallbackHandle = null;

    gameStateManager.removeOnGameInfoConsoleTileHighlightRequestCallback( this.onGameInfoConsoleTileHighlightRequest );

    // Reset initialization flag
    this.isInitialized = false;
  }

  componentDidUpdate()
  {
    const
      {
        gameStateData,
        lastPlayerTileHighlightRequests
      } = this.state;

    const playerData = gameStateData ? gameStateData.playerData : null;

    if( playerData != null && lastPlayerTileHighlightRequests.length === 0 )
    {
      // Populate the 'lastPlayerTileHighlightRequests' array with initial values per player index

      this.setState( { lastPlayerTileHighlightRequests: Array( playerData.playersJoined.length ).fill( 0 ) } );
    }
  }


  handleKeyDown = ( event ) =>
  {
    if( event.keyCode === 70 )  // 'F' - key - "FILL/FULL SCREEN" shortcut
    {
      this.enableAutoCameraFramingMode();
    }

    if( process.env.NODE_ENV === 'development' )
    {
      // G - 71
      // M - 77
      // '1' - 49
      // '2' - 50
      // '3' - 51

      if( event.keyCode === 49 )  //  '1' key - End Game Phase
      {
        this.setState( { debugViewEndGamePhasePanel: !this.state.debugViewEndGamePhasePanel } );
      }

      if( event.keyCode === 50 )	// '2' key -  Game over screen
      {
        this.setState( { debugViewGameOverPanel: !this.state.debugViewGameOverPanel } );
      }

      // if( event.keyCode === 77 )  // 'M' Key - 'debug show a meeple success returning anim'
      // {
      //   let tileCoord = { x: utils.getRandomInt( -2, 2 ), y: utils.getRandomInt( -2, 2 ) }

      //   gameStateManager.broadcastMeepleReturnAnimationRequest(
      //     {
      //       meepleDatas: [
      //         {
      //           isFarmer: false,
      //           localMeepleCoords: { x: 0, y: 0.32 },
      //           tileHash: utils.coordToHash( tileCoord.x, tileCoord.y )
      //         }
      //       ],
      //       playerColourHex: "#2b6fc1",
      //       playerColourID: "blue",
      //       pointsScored: Math.random() > 0.5 ? utils.getRandomInt( 0, 24 ) : 0,
      //       featureType: 0,
      //       featureMinMaxBounds: {
      //         min: utils.coordToHash( tileCoord.x + utils.getRandomInt( -2, 0 ), tileCoord.y + utils.getRandomInt( -2, 0 ) ),
      //         max: utils.coordToHash( tileCoord.x + utils.getRandomInt( 0, 2 ), tileCoord.y + utils.getRandomInt( 0, 2 ) )
      //       }
      //     } );
      // }

    }
  };

  onGameInfoConsoleTileHighlightRequest = ( tileCoords ) =>
  {
    // console.log( 'onGameInfoConsoleTileHighlightRequest() tileCoords', tileCoords );

    this.setState( {
      consoleInfoHighlightTile: tileCoords,
      consoleInfoHighlightRequestIndex: this.state.consoleInfoHighlightRequestIndex + 1
    } );
  }

  onMeeplePlacementSkipClick = () =>
  {
    // Tell server that player has skipped their Meeple placement stage
    emit.playerSkipMeeplePlacement();

    this.pixiBoardRef.current.meeplePlacementInteractionHandlerRef.current.onMeeplePlacementSkipped();
  }

  toggleFieldStatusView = () =>
  {
    this.setState( { viewFieldStates: !this.state.viewFieldStates } );
  }

  onRemainingTilesInfoPanelClick = () =>
  {
    this.setState( { viewRemainingTilesInfoPanel: !this.state.viewRemainingTilesInfoPanel } );
  }

  onGameOverViewBoardButtonClicked = () =>
  {
    this.setState( { gameOverScreenViewingBoardState: true } );
  }

  onGameOverViewResultsButtonClicked = () =>
  {
    this.setState( { gameOverScreenViewingBoardState: false } );
  }

  onGameOverBackToLobbyButtonClicked = () =>
  {
    window.location.href = "/";
  }


  enableAutoCameraFramingMode = () =>
  {
    if( !gameStateManager.autoCameraFramingModeState )
    {
      gameStateManager.setAutoCameraFramingModeState( true );
    }
  }

  disableAutoCameraFramingMode = () =>
  {
    if( gameStateManager.autoCameraFramingModeState )
    {
      gameStateManager.setAutoCameraFramingModeState( false );
    }
  }

  render()
  {
    const
      {
        clientId,
        stageRenderData,
        sidePanelWidth
      } = this.props;

    const
      {
        viewFieldStates,
        viewRemainingTilesInfoPanel,
        gameStateData,
        lastPlayerTileHighlightRequests,
        consoleInfoHighlightTile,
        consoleInfoHighlightRequestIndex,
        gameOverScreenViewingBoardState
      } = this.state;

    const stageWidth = stageRenderData.width;
    const stageHeight = stageRenderData.height;
    const renderScale = stageRenderData.scale;

    // Grab out the bits we need from the gameStateData object
    const boardTiles = gameStateData ? gameStateData.boardTiles : null;
    const boardMeeples = gameStateData ? gameStateData.boardMeeples : null;
    const boardFields = gameStateData ? gameStateData.boardFields : null;
    const boardAreaBL = gameStateData ? utils.hashToCoord( gameStateData.boardSquareTileHashBL ) : { x: 0, y: 0 };
    const boardAreaTR = gameStateData ? utils.hashToCoord( gameStateData.boardSquareTileHashTR ) : { x: 0, y: 0 };
    const playerData = gameStateData ? gameStateData.playerData : null;
    const validTilePlacements = gameStateData ? gameStateData.validTilePlacements : null;
    const opponentValidTilePlacements = gameStateData ? gameStateData.opponentValidTilePlacements : null;
    const validMeeplePlacements = gameStateData ? gameStateData.validMeeplePlacements : null;
    const currentTileSprite = gameStateData ? gameStateData.currentTileSprite : null;
    const numTilesRemaining = gameStateData ? gameStateData.numTilesRemaining : null;
    const tileIdCounts = gameStateData ? gameStateData.tileIdCounts : null;
    const timerData = gameStateData ? gameStateData.timerData : null;
    const lastTilesPlacedByPlayers = gameStateData ? gameStateData.lastTilesPlacedByPlayers : null;
    const doesBoardHaveFarmers = gameStateData ? gameStateData.doesBoardHaveFarmers : false;

    const viewEndGamePhasePanel = this.state.debugViewEndGamePhasePanel
      ? true
      : gameStateData && gameStateData.gameState === GAME_STATE.END_GAME_PHASE;

    const viewGameOverPanel = this.state.debugViewGameOverPanel
      ? true
      : gameStateData && gameStateData.gameState === GAME_STATE.GAME_OVER;

    const showFarmFieldsButton = doesBoardHaveFarmers && boardFields;

    // console.log( "PixiGame Render. boardTiles", boardTiles, "socketRoomBoardTiles", gameStateManager.socketRoomBoardTiles );
    // console.log("PIXI Current Tile Sprite : " + currentTileSprite + ", renderScale : " + renderScale );
    // console.log(validTilePlacements);

    // Get player team colours
    let playerTeamColourHex = "";
    let playerTeamColourID = "";
    let playerTeamIndex = -1;
    let teamColours = [];

    if( playerData )
    {
      for( let idx = 0; idx < playerData.playersJoined.length; idx++ )
      {
        if( playerData.playersJoined[ idx ].socketID === clientId )
        {
          playerTeamColourHex = playerData.playersJoined[ idx ].colourHex;
          playerTeamColourID = playerData.playersJoined[ idx ].colourID;
          playerTeamIndex = idx;
        }

        teamColours.push( playerData.playersJoined[ idx ].colourHex );
      }
    }



    let endGamePhasePanelContents = [];

    if( viewEndGamePhasePanel && playerData )
    {
      endGamePhasePanelContents.push(
        <PixiEndGamePhasePanel
          key={ "end-game-phase-panel" }
          stageRenderData={ stageRenderData }
          playerData={ playerData }
          clientId={ clientId }
        />
      );
    }



    let gameOverPanelContents = [];

    if( viewGameOverPanel && playerData )
    {
      const playScreenWidth = stageRenderData.width - ( sidePanelWidth * renderScale );
      const playScreenHeight = stageRenderData.height;

      if( !gameOverScreenViewingBoardState )
      {
        gameOverPanelContents.push(
          <PixiEndGameOverlay
            key={ "game-over-panel" }
            stageRenderData={ stageRenderData }
            playerData={ playerData }
            clientId={ clientId }
            playScreenWidth={ playScreenWidth }
            playScreenHeight={ playScreenHeight }
          /> );
      }

      gameOverPanelContents.push(
        <PixiScaledButton
          key={ "view-results-button" }
          x={ 0 }
          y={ gameStateManager.canvasRefHeight - 40 }
          stageRenderData={ stageRenderData }
          showActive={ gameOverScreenViewingBoardState }
          width={ 340 }
          height={ 42 }
          text={ gameOverScreenViewingBoardState ? "View Results" : "View Board" }
          onClick={ gameOverScreenViewingBoardState ? this.onGameOverViewResultsButtonClicked : this.onGameOverViewBoardButtonClicked }
        />,

        <PixiScaledButton
          key={ "back-to-lobby-button" }
          x={ stageRenderData.width - ( 656 * stageRenderData.scale ) }
          y={ gameStateManager.canvasRefHeight - 40 }
          stageRenderData={ stageRenderData }
          width={ 340 }
          height={ 42 }
          text={ "Back To Lobby" }
          onClick={ this.onGameOverBackToLobbyButtonClicked }
        />
      );
    }


    let remainingTilesInfoPanelContent = [];

    if( viewRemainingTilesInfoPanel
      && !viewGameOverPanel
      && tileIdCounts )
    {
      remainingTilesInfoPanelContent.push(

        <PixiScaledSprite
          key={ "current_turn_tile_BG" }
          imageSrc={ "./ui/panel_bg.png" }
          isNineSlice={ true }
          cornerRadius={ 15 }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 317 * stageRenderData.scale ) }
          y={ 41 }
          width={ 443 }
          height={ 574 }
          anchor={ { x: 1, y: 0 } }
        />,
      );

      // console.log( 'tileIdCounts', tileIdCounts );

      let x_spacing = 80;
      let y_spacing = 100;
      let tileRenderSize = 75;
      let numTilesPerRow = 5;

      const startingTotalTileCount = tileIdCounts[ 'starting-total' ];


      for( let tIdx = 0; tIdx < 24; tIdx++ )
      {
        let columnIndex = tIdx % numTilesPerRow;
        let rowIndex = Math.floor( tIdx / numTilesPerRow );
        let tileCountKey = 'b_' + ( tIdx + 1 );
        let tileCount = tileIdCounts[ tileCountKey ] ?? 0;
        let spriteName = `tile_base_${tIdx + 1}`;

        remainingTilesInfoPanelContent.push(

          <PixiScaledSprite
            key={ "tile_count_sprite_b_" + ( tIdx + 1 ) }
            imageSrc={ `./tiles/${tileFolderName}/${spriteName}.png` }
            stageRenderData={ stageRenderData }
            x={ stageRenderData.width - ( 745 * stageRenderData.scale ) + ( columnIndex * x_spacing * stageRenderData.scale ) }
            y={ 89 + ( y_spacing * rowIndex ) }
            width={ tileRenderSize }
            height={ tileRenderSize }
            anchor={ { x: 0, y: 0 } }
            tint={ currentTileSprite === spriteName ? 0xbbbbbb : 0xffffff }
          />,

          <PixiScaledText
            key={ "tile_count_tally_b_" + ( tIdx + 1 ) }
            text={ tileCount.toString() }
            stageRenderData={ stageRenderData }
            x={ stageRenderData.width - ( 705 * stageRenderData.scale ) + ( columnIndex * x_spacing * stageRenderData.scale ) }
            y={ 166 + ( y_spacing * rowIndex ) }
            anchor={ { x: 0.5, y: 0 } }
            fontSize={ 17 }
            style={ this.textStyle }
          />

        );
      }

      remainingTilesInfoPanelContent.push(

        <PixiScaledText
          key={ "tiles_remaining_title" }
          text={ "Remaining Tiles" }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 746 * stageRenderData.scale ) }
          y={ 62 }
          anchor={ { x: 0, y: 0.5 } }
          fontSize={ 17 }
          style={ this.textStyle }
        />,

        <PixiScaledText
          key={ "tiles_remaining_tally" }
          text={ numTilesRemaining + " / " + startingTotalTileCount }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 330 * stageRenderData.scale ) }
          y={ 62 }
          anchor={ { x: 1, y: 0.5 } }
          fontSize={ 17 }
          style={ this.textStyle }
        />,
      );
    }





    let currentTurnStateContent = [];

    if( !viewGameOverPanel )
    {
      if( currentTileSprite )
      {
        currentTurnStateContent.push(

          <PixiScaledSprite
            key={ "current_turn_tile_BG" }
            imageSrc={ "./ui/panel_bg.png" }
            isNineSlice={ true }
            cornerRadius={ 15 }
            stageRenderData={ stageRenderData }
            x={ stageRenderData.width - ( 317 * stageRenderData.scale ) }
            y={ gameStateManager.canvasRefHeight - 37 }
            width={ 143 }
            height={ 184 }
            anchor={ { x: 1, y: 1 } }
          />,

          <PixiScaledSprite
            key={ "current_tile" }
            imageSrc={ `./tiles/${tileFolderName}/${currentTileSprite}.png` }
            stageRenderData={ stageRenderData }
            x={ stageRenderData.width - ( 325 * stageRenderData.scale ) }
            y={ gameStateManager.canvasRefHeight - 89 }
            width={ 127 }
            height={ 127 }
            anchor={ { x: 1, y: 1 } }
          />
        );
      }
      else
      {
        //
        currentTurnStateContent.push(
          <PixiScaledSprite
            key={ "current_turn_tile_BG" }
            imageSrc={ "./ui/panel_bg.png" }
            isNineSlice={ true }
            cornerRadius={ 15 }
            stageRenderData={ stageRenderData }
            x={ stageRenderData.width - ( 317 * stageRenderData.scale ) }
            y={ gameStateManager.canvasRefHeight - 37 }
            width={ 143 }
            height={ 52 }
            anchor={ { x: 1, y: 1 } }
          />,
        );
      }
    }

    if( !viewGameOverPanel && numTilesRemaining !== undefined )
    {
      // Show num tiles remaining.

      currentTurnStateContent.push(

        <PixiScaledSprite
          key={ "remaining_tiles_block_BG" }
          imageSrc={ viewRemainingTilesInfoPanel ? "./ui/Button BG - Active.png" : "./ui/Button BG - Inactive.png" }
          isNineSlice={ true }
          cornerRadius={ 15 }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 321 * stageRenderData.scale ) }
          y={ gameStateManager.canvasRefHeight - 41 }
          width={ 134 }
          height={ 44 }
          anchor={ { x: 1, y: 1 } }
          onClick={ () => { this.onRemainingTilesInfoPanelClick(); } }
        />,

        <PixiScaledText
          key={ "tiles_remaining" }
          text={ numTilesRemaining + "" }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 386 * stageRenderData.scale ) }
          y={ gameStateManager.canvasRefHeight - 67 }
          anchor={ { x: 0.5, y: 0.5 } }
          fontSize={ 17 }
          style={ this.textStyle }
        />,

        <PixiScaledSprite
          key={ "tile_stack_icon" }
          imageSrc={ "./ui/tile_stack_icon.png" }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 425 * stageRenderData.scale ) }
          y={ gameStateManager.canvasRefHeight - 66 }
          width={ 27 }
          height={ 27 }
          anchor={ { x: 0.5, y: 0.5 } }
        />,

        <PixiScaledSprite
          key={ "info_icon" }
          imageSrc={ "./ui/info_icon.png" }
          stageRenderData={ stageRenderData }
          x={ stageRenderData.width - ( 345 * stageRenderData.scale ) }
          y={ gameStateManager.canvasRefHeight - 66 }
          width={ 18 }
          height={ 18 }
          anchor={ { x: 0.5, y: 0.5 } }
        />
      );
    }

    return (

      <Stage
        width={ stageWidth }
        height={ stageHeight }
        options={ { backgroundColor: 0xc7ab8c } }
        style={ {
          touchAction: "none",
          position: "absolute",
          display: "block",
          left: "50%",
          top: stageRenderData.stageStyleTop + "px",
          transform: "translate(-50%, 0%)",
          border: "2px solid black"
        } }
      >

        <PixiBoard
          ref={ this.pixiBoardRef }
          screenWidth={ stageWidth }
          screenHeight={ stageHeight }
          sidePanelWidth={ sidePanelWidth }
          boardAreaBL={ boardAreaBL }
          boardAreaTR={ boardAreaTR }
          boardTiles={ boardTiles }
          boardMeeples={ boardMeeples }
          currentTileSprite={ currentTileSprite }
          stageRenderData={ stageRenderData }
          playerData={ playerData }
          playerTeamColourHex={ playerTeamColourHex }
          playerTeamColourID={ playerTeamColourID }
          playerTeamIndex={ playerTeamIndex }
          teamColours={ teamColours }
          validTilePlacements={ validTilePlacements }
          opponentValidTilePlacements={ opponentValidTilePlacements }
          validMeeplePlacements={ validMeeplePlacements }
          lastTilesPlacedByPlayers={ lastTilesPlacedByPlayers }
          lastPlayerTileHighlightRequests={ lastPlayerTileHighlightRequests }
          consoleInfoHighlightTile={ consoleInfoHighlightTile }
          consoleInfoHighlightRequestIndex={ consoleInfoHighlightRequestIndex }
          interactive={ !viewGameOverPanel || gameOverScreenViewingBoardState }
          fieldStateData={ viewFieldStates ? boardFields : null }
          tileFolderName={ tileFolderName }
          numTilesRemaining={ numTilesRemaining }
          onDisableAutoCameraFramingMode={ this.disableAutoCameraFramingMode }
          isEndGamePhaseCameraMode={ gameStateData && ( gameStateData.gameState == GAME_STATE.END_GAME_PHASE ) }
        />

        { remainingTilesInfoPanelContent }
        { currentTurnStateContent }

        { playerData && (

          <PixiGamePlayersInfoPanel
            stageRenderData={ stageRenderData }
            textStyle={ this.textStyle }
            playerData={ playerData }
            clientPlayerIndex={ playerTeamIndex }
            panelWidth={ 320 }
            panelHeight={ 359 }
            x={ stageRenderData.width - 0 }
            y={ gameStateManager.canvasRefHeight + 1 }
            onPlayerRowClicked={ ( index ) =>
            {

              let latestHighlightRequests = this.state.lastPlayerTileHighlightRequests;

              latestHighlightRequests[ index ] += 1;

              this.setState( { lastPlayerTileHighlightRequests: latestHighlightRequests } );

            } }
          />
        ) }

        { !viewGameOverPanel && timerData && (
          <>
            <PixiTurnTimer stageRenderData={ stageRenderData }
              timerData={ timerData }
              textStyle={ this.textStyle } />

            <Container>
              <PixiScaledSprite
                imageSrc={ "./ui/panel_bg.png" }
                isNineSlice={ true }
                cornerRadius={ 15 }
                stageRenderData={ stageRenderData }
                x={ stageRenderData.width - ( 401 * stageRenderData.scale ) }
                y={ gameStateManager.canvasRefHeight + 3 }
                width={ 333 }
                height={ 42 }
                anchor={ { x: 1, y: 1 } }
              />

              <PixiScaledText
                text={ timerData.context }
                stageRenderData={ stageRenderData }
                x={ stageRenderData.width - ( 565 * stageRenderData.scale ) }
                y={ gameStateManager.canvasRefHeight - 22 }
                anchor={ { x: 0.5, y: 0.5 } }
                style={ this.textStyle }
                fontSize={ 17 }
              />

            </Container>
          </>

        ) }


        { /* Check to show a 'Skip Tilefolk Placement' button. */ }
        { validMeeplePlacements && (

          <PixiScaledButton
            x={ showFarmFieldsButton ? 58 * stageRenderData.scale : 0 }
            y={ gameStateManager.canvasRefHeight - 40 }
            stageRenderData={ stageRenderData }
            width={ 340 }
            height={ 42 }
            text={ "Skip Tilefolk Placement?" }
            onClick={ () => { this.onMeeplePlacementSkipClick(); } }
          />

        ) }

        { /* Check to show a num spectators count  */ }
        { playerData && playerData.numSpectators > 0 && (

          <Container
            x={ 40 }
            y={ 22 }>
            <PixiScaledSprite
              imageSrc={ "./ui/spectator-icon.png" }
              stageRenderData={ stageRenderData }
              x={ 0 }
              y={ 0 }
              width={ 40 }
              height={ 40 }
              anchor={ { x: 0, y: 0.5 } }
            />

            <PixiScaledText
              text={ playerData ? playerData.numSpectators : "0" }
              stageRenderData={ stageRenderData }
              x={ 40 * stageRenderData.scale }
              y={ 0 }
              anchor={ { x: 0, y: 0.5 } }
              style={ this.textStyle }
            />

          </Container>
        ) }

        { showFarmFieldsButton
          && (
            <PixiScaledSprite
              imageSrc={ viewFieldStates ? "./ui/Field Button - Active.png" : "./ui/Field Button - Inactive.png" }
              stageRenderData={ stageRenderData }
              x={ 2 }
              y={ gameStateManager.canvasRefHeight - ( viewGameOverPanel ? 40 : 1 ) }
              width={ 60 }
              height={ 56 }
              anchor={ { x: 0, y: 1 } }
              onClick={ () => { this.toggleFieldStatusView(); } }
            />

          ) }

        <PixiAutoCameraFramingDisplay stageRenderData={ stageRenderData } />

        { endGamePhasePanelContents }
        { gameOverPanelContents }

      </Stage>
    );
  }
}


export default PixiGame;
